export default [
  {
    path: '/admin/bank-profiles',
    name: 'bank-profile',
    meta: { requiresAuth: true },
    component: () => import('@/pages/corporate/bank-profile')
  }
]
